/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClassifierCategory } from '../models/ClassifierCategory';
import type { CreateCommonClassifierElementRequest } from '../models/CreateCommonClassifierElementRequest';
import type { CreateCommonClassifierElementResponse } from '../models/CreateCommonClassifierElementResponse';
import type { CreateCUATMClassifierElementRequest } from '../models/CreateCUATMClassifierElementRequest';
import type { CreateCUATMClassifierElementResponse } from '../models/CreateCUATMClassifierElementResponse';
import type { CreateDeviceTypeClassifierElementRequest } from '../models/CreateDeviceTypeClassifierElementRequest';
import type { CreateDeviceTypeClassifierElementResponse } from '../models/CreateDeviceTypeClassifierElementResponse';
import type { CreateInvestigationClassifierRequest } from '../models/CreateInvestigationClassifierRequest';
import type { CreateInvestigationClassifierResponse } from '../models/CreateInvestigationClassifierResponse';
import type { CreatePreventionTreatmentContingentRequest } from '../models/CreatePreventionTreatmentContingentRequest';
import type { CreatePreventionTreatmentContingentResponse } from '../models/CreatePreventionTreatmentContingentResponse';
import type { CreateReferenceIntervalClassifierElementRequest } from '../models/CreateReferenceIntervalClassifierElementRequest';
import type { CreateReferenceIntervalClassifierElementResponse } from '../models/CreateReferenceIntervalClassifierElementResponse';
import type { CreateResultValueOptionRequest } from '../models/CreateResultValueOptionRequest';
import type { CreateResultValueOptionResponse } from '../models/CreateResultValueOptionResponse';
import type { CreateRiskGroupClassifierElementRequest } from '../models/CreateRiskGroupClassifierElementRequest';
import type { CreateRiskGroupClassifierElementResponse } from '../models/CreateRiskGroupClassifierElementResponse';
import type { CreateTreatmentRegimenTypeRequest } from '../models/CreateTreatmentRegimenTypeRequest';
import type { CreateTreatmentRegimenTypeResponse } from '../models/CreateTreatmentRegimenTypeResponse';
import type { GetCategoryListResponse } from '../models/GetCategoryListResponse';
import type { GetClassifierListResponse } from '../models/GetClassifierListResponse';
import type { GetClassifierResponse } from '../models/GetClassifierResponse';
import type { GetCommonClassifierElementListResponse } from '../models/GetCommonClassifierElementListResponse';
import type { GetCommonClassifierElementResponse } from '../models/GetCommonClassifierElementResponse';
import type { GetCountryClassifierElementListResponse } from '../models/GetCountryClassifierElementListResponse';
import type { GetCuatmClassifierElementListResponse } from '../models/GetCuatmClassifierElementListResponse';
import type { GetCuatmClassifierElementResponse } from '../models/GetCuatmClassifierElementResponse';
import type { GetIcd10AmClassifierElementListResponse } from '../models/GetIcd10AmClassifierElementListResponse';
import type { GetIcd10AmClassifierElementResponse } from '../models/GetIcd10AmClassifierElementResponse';
import type { GetListResultValueOptionsResponse } from '../models/GetListResultValueOptionsResponse';
import type { GetPregnancyStatusClassifierElementListResponse } from '../models/GetPregnancyStatusClassifierElementListResponse';
import type { GetReferenceIntervalClassifierElementListResponse } from '../models/GetReferenceIntervalClassifierElementListResponse';
import type { GetReferenceIntervalClassifierElementResponse } from '../models/GetReferenceIntervalClassifierElementResponse';
import type { GetResultValueOptionResponse } from '../models/GetResultValueOptionResponse';
import type { GetRiskGroupClassifierElementListResponse } from '../models/GetRiskGroupClassifierElementListResponse';
import type { GetRiskGroupClassifierElementResponse } from '../models/GetRiskGroupClassifierElementResponse';
import type { GetSystemKeyListResponse } from '../models/GetSystemKeyListResponse';
import type { Icd10AmElementType } from '../models/Icd10AmElementType';
import type { InstitutionDeviceTypeDto } from '../models/InstitutionDeviceTypeDto';
import type { InvestigationTestTypeCategory } from '../models/InvestigationTestTypeCategory';
import type { InvestigationTestTypeDto2 } from '../models/InvestigationTestTypeDto2';
import type { InvestigationTypeDto } from '../models/InvestigationTypeDto';
import type { ListSortDirection } from '../models/ListSortDirection';
import type { SearchInstitutionDeviceTypeQueryResponse } from '../models/SearchInstitutionDeviceTypeQueryResponse';
import type { SearchInvestigationTestTypesQueryResponse } from '../models/SearchInvestigationTestTypesQueryResponse';
import type { SearchInvestigationTypeQueryResponse } from '../models/SearchInvestigationTypeQueryResponse';
import type { SearchPreventionTreatmentContingentResponse } from '../models/SearchPreventionTreatmentContingentResponse';
import type { SearchTreatmentRegimenTypeResponse } from '../models/SearchTreatmentRegimenTypeResponse';
import type { SetIcd10AmTypeRequest } from '../models/SetIcd10AmTypeRequest';
import type { SetSystemKeyRequest } from '../models/SetSystemKeyRequest';
import type { TreatmentRegimenTypeDto } from '../models/TreatmentRegimenTypeDto';
import type { UpdateClassifierRequest } from '../models/UpdateClassifierRequest';
import type { UpdateCommonClassifierElementRequest } from '../models/UpdateCommonClassifierElementRequest';
import type { UpdateCommonClassifierElementResponse } from '../models/UpdateCommonClassifierElementResponse';
import type { UpdateCuatmClassifierElementRequest } from '../models/UpdateCuatmClassifierElementRequest';
import type { UpdateCuatmClassifierElementResponse } from '../models/UpdateCuatmClassifierElementResponse';
import type { UpdateDeviceTypeClassifierElementRequest } from '../models/UpdateDeviceTypeClassifierElementRequest';
import type { UpdateDeviceTypeClassifierElementResponse } from '../models/UpdateDeviceTypeClassifierElementResponse';
import type { UpdateIcd10AmClassifierElementRequest } from '../models/UpdateIcd10AmClassifierElementRequest';
import type { UpdateIcd10AmClassifierElementResponse } from '../models/UpdateIcd10AmClassifierElementResponse';
import type { UpdateInvestigationClassifierRequest } from '../models/UpdateInvestigationClassifierRequest';
import type { UpdatePreventionTreatmentContingentRequest } from '../models/UpdatePreventionTreatmentContingentRequest';
import type { UpdateReferenceIntervalClassifierElementRequest } from '../models/UpdateReferenceIntervalClassifierElementRequest';
import type { UpdateReferenceIntervalClassifierElementResponse } from '../models/UpdateReferenceIntervalClassifierElementResponse';
import type { UpdateResultValueOptionRequest } from '../models/UpdateResultValueOptionRequest';
import type { UpdateResultValueOptionResponse } from '../models/UpdateResultValueOptionResponse';
import type { UpdateRiskGroupClassifierElementRequest } from '../models/UpdateRiskGroupClassifierElementRequest';
import type { UpdateRiskGroupClassifierElementResponse } from '../models/UpdateRiskGroupClassifierElementResponse';
import type { UpdateTreatmentRegimenTypeRequest } from '../models/UpdateTreatmentRegimenTypeRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClassifierService {
    /**
     * Updates a classifier.
     * Updates a classifier with provided details.
     * @param id Classifier identifier.
     * @param requestBody
     * @returns any The classifier has been updated successfully.
     * @throws ApiError
     */
    public static updateClassifierEndpoint(
        id: string,
        requestBody: UpdateClassifierRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/classifiers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The classifier has not been found.`,
            },
        });
    }
    /**
     * Gets a classifier.
     * Gets a classifier with details.
     * @param id Classifier identifier.
     * @returns GetClassifierResponse The classifier has been found.
     * @throws ApiError
     */
    public static getClassifierEndpoint(
        id: string,
    ): CancelablePromise<GetClassifierResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The classifier has not been found.`,
            },
        });
    }
    /**
     * Update a treatment regimen type.
     * This endpoint requires the following permissions: [  ]
     * @param id The unique identifier of the treatment regimen type
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateTreatmentRegimenTypeEndpoint(
        id: string,
        requestBody: UpdateTreatmentRegimenTypeRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/treatment/regimen-types/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Get a treatment regimen type by its identifier.
     * This endpoint requires the following permissions: [  ]
     * @param id Gets or sets the unique identifier for the treatment regimen type resource.
     * @returns TreatmentRegimenTypeDto Success
     * @throws ApiError
     */
    public static getTreatmentRegimenTypeEndpoint(
        id: string,
    ): CancelablePromise<TreatmentRegimenTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/treatment/regimen-types/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Delete a treatment regimen type by its identifier.
     * This endpoint requires the following permissions: [  ]
     * @param id Gets or initializes the unique identifier associated with the
     * Treatment Regimen Type to be deleted.
     * @returns void
     * @throws ApiError
     */
    public static deleteTreatmentRegimenTypeEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/treatment/regimen-types/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Search for treatment regimen types.
     * This endpoint requires the following permissions: [  ]
     * @param pageNumber Gets or sets the page number.
     * @param pageSize Gets or sets the page size. If not specified, no limit is applied.
     * @param searchTerm Gets or sets the search term used to filter the results.
     * @param sortDirection Specifies the direction (ascending or descending) to sort the items.
     * If null, the default sorting direction is applied.
     * @param ids Collection of treatment regimen type IDs to filter by.
     * @param typeIds Collection of treatment type IDs to filter by.
     * @returns SearchTreatmentRegimenTypeResponse Success
     * @throws ApiError
     */
    public static searchTreatmentRegimenTypeEndpoint(
        pageNumber?: number | null,
        pageSize?: number | null,
        searchTerm?: string | null,
        sortDirection?: ListSortDirection | null,
        ids?: Array<string> | null,
        typeIds?: Array<string> | null,
    ): CancelablePromise<SearchTreatmentRegimenTypeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/treatment/regimen-types/',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortDirection': sortDirection,
                'ids': ids,
                'typeIds': typeIds,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Create a new treatment regimen type.
     * This endpoint requires the following permissions: [  ]
     * @param requestBody
     * @returns CreateTreatmentRegimenTypeResponse Success
     * @throws ApiError
     */
    public static createTreatmentRegimenTypeEndpoint(
        requestBody: CreateTreatmentRegimenTypeRequest,
    ): CancelablePromise<CreateTreatmentRegimenTypeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/treatment/regimen-types/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Update a prevention treatment contingent.
     * This endpoint requires the following permissions: [  ]
     * @param id The unique identifier of the prevention treatment contingent
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updatePreventionTreatmentContingentEndpoint(
        id: string,
        requestBody: UpdatePreventionTreatmentContingentRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/treatment/prevention-contingent/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Get a prevention treatment contingent by its identifier.
     * This endpoint requires the following permissions: [  ]
     * @param id Gets or sets the unique identifier for the prevention treatment contingent resource.
     * @returns TreatmentRegimenTypeDto Success
     * @throws ApiError
     */
    public static getPreventionTreatmentContingentEndpoint(
        id: string,
    ): CancelablePromise<TreatmentRegimenTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/treatment/prevention-contingent/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Delete a prevention treatment contingent by its identifier.
     * This endpoint requires the following permissions: [  ]
     * @param id Gets or initializes the unique identifier associated with the
     * Prevention Treatment Contingent to be deleted.
     * @returns void
     * @throws ApiError
     */
    public static deletePreventionTreatmentContingentEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/treatment/prevention-contingent/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Search for prevention treatment contingents.
     * This endpoint requires the following permissions: [  ]
     * @param pageNumber Gets or sets the page number.
     * @param pageSize Gets or sets the page size. If not specified, no limit is applied.
     * @param searchTerm Gets or sets the search term used to filter the results.
     * @param sortDirection Specifies the direction (ascending or descending) to sort the items.
     * If null, the default sorting direction is applied.
     * @param ids Collection of prevention treatment contingent IDs to filter by.
     * @param typeIds Collection of treatment type IDs to filter by.
     * @returns SearchPreventionTreatmentContingentResponse Success
     * @throws ApiError
     */
    public static searchPreventionTreatmentContingentEndpoint(
        pageNumber?: number | null,
        pageSize?: number | null,
        searchTerm?: string | null,
        sortDirection?: ListSortDirection | null,
        ids?: Array<string> | null,
        typeIds?: Array<string> | null,
    ): CancelablePromise<SearchPreventionTreatmentContingentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/treatment/prevention-contingent/',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'sortDirection': sortDirection,
                'ids': ids,
                'typeIds': typeIds,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Create a new prevention treatment contingent.
     * This endpoint requires the following permissions: [  ]
     * @param requestBody
     * @returns CreatePreventionTreatmentContingentResponse Success
     * @throws ApiError
     */
    public static createPreventionTreatmentContingentEndpoint(
        requestBody: CreatePreventionTreatmentContingentRequest,
    ): CancelablePromise<CreatePreventionTreatmentContingentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/treatment/prevention-contingent/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Lists the system keys an admin can map to the elements of a classifier (empty when the type has none).
     * @param id
     * @returns GetSystemKeyListResponse Success
     * @throws ApiError
     */
    public static getSystemKeyListEndpoint(
        id: string,
    ): CancelablePromise<GetSystemKeyListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/{id}/system-keys',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Updates a Risk group classifier element.
     * Updates a Risk group classifier element with provided details.
     * @param elementId Element identifier.
     * @param requestBody
     * @returns UpdateRiskGroupClassifierElementResponse The Risk Group classifier element has been updated successfully.
     * @throws ApiError
     */
    public static updateRiskGroupClassifierElementEndpoint(
        elementId: string,
        requestBody: UpdateRiskGroupClassifierElementRequest,
    ): CancelablePromise<UpdateRiskGroupClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/classifiers/risk-groups/{elementId}',
            path: {
                'elementId': elementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Classifier/CUATM classifier element not found.`,
            },
        });
    }
    /**
     * Gets a Risk Group classifier element.
     * Gets a Risk Group classifier element with details.
     * @param elementId Element identifier.
     * @returns GetRiskGroupClassifierElementResponse The Risk Group classifier element has been retrieved successfully.
     * @throws ApiError
     */
    public static getRiskGroupClassifierElementEndpoint(
        elementId: string,
    ): CancelablePromise<GetRiskGroupClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/risk-groups/{elementId}',
            path: {
                'elementId': elementId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Risk Group classifier element not found.`,
            },
        });
    }
    /**
     * Delete a Risk Group classifier element.
     * Delete a Risk Group classifier element.
     * @param elementId Element identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteRiskGroupClassifierElementEndpoint(
        elementId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/classifiers/risk-groups/{elementId}',
            path: {
                'elementId': elementId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `Risk Group classifier element not found.`,
            },
        });
    }
    /**
     * Gets a list of Risk Group classifier elements.
     * Gets a list of Risk Group classifier elements.
     * @returns GetRiskGroupClassifierElementListResponse List of Risk Group classifier elements has been retrieved successfully.
     * @throws ApiError
     */
    public static getRiskGroupClassifierElementListEndpoint(): CancelablePromise<GetRiskGroupClassifierElementListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/risk-groups',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a new Risk Group classifier element.
     * This endpoint requires the following permissions: [  ]
     * @param requestBody
     * @returns CreateRiskGroupClassifierElementResponse The Risk group classifier element has been updated successfully.
     * @throws ApiError
     */
    public static createRiskGroupClassifierElementEndpoint(
        requestBody: CreateRiskGroupClassifierElementRequest,
    ): CancelablePromise<CreateRiskGroupClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/classifiers/risk-groups',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Gets a list of pregnancy status classifier elements.
     * Gets a list of pregnancy status classifier elements.
     * @param id Classifier identifier.
     * @returns GetPregnancyStatusClassifierElementListResponse List of pregnancy status classifier elements has been retrieved successfully.
     * @throws ApiError
     */
    public static getPregnancyStatusClassifierElementListEndpoint(
        id: string,
    ): CancelablePromise<GetPregnancyStatusClassifierElementListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/{id}/pregnancy-status-elements',
            path: {
                'id': id,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Updates an existing Investigation Type classifier.
     * Updates a classifier that represents a medical investigation type, allowing modification of its display name, technical metadata, and classifier relationships such as equipment, infection, work method, and specimen.
     * @param id The unique identifier of the investigation type to update.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateInvestigationClassifierEndpoint(
        id: string,
        requestBody: UpdateInvestigationClassifierRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/classifiers/investigations/types/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request body or parameters are invalid.`,
                401: `The user is not authorized to perform this operation.`,
                404: `The investigation classifier was not found.`,
            },
        });
    }
    /**
     * Retrieves an Investigation Type classifier.
     * Fetches details for a specific Investigation Type classifier element based on its unique identifier.
     * @param id Gets the identifier of the investigation type classifier.
     * @returns InvestigationTypeDto Success
     * @throws ApiError
     */
    public static getInvestigationClassifierEndpoint(
        id: string,
    ): CancelablePromise<InvestigationTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/investigations/types/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The provided identifier is invalid or missing.`,
                401: `The user is not authorized to perform this operation.`,
                404: `No Investigation Type classifier element was found for the given identifier.`,
            },
        });
    }
    /**
     * Deletes an Investigation Type classifier element.
     * Deletes a specific Investigation Type classifier element identified by its unique ID.
     * @param id Gets or sets the unique identifier of the element.
     * @returns any The Investigation Type classifier element was successfully deleted.
     * @throws ApiError
     */
    public static deleteInvestigationTypeClassifierEndpoint(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/classifiers/investigations/types/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The provided identifier is invalid or missing.`,
                401: `The user is not authorized to perform this operation.`,
                404: `No Investigation Type classifier element was found for the given identifier.`,
            },
        });
    }
    /**
     * Retrieves a filtered list of Investigation Type classifiers.
     * Fetches a paginated list of Investigation Type classifier elements with optional filters like search term, specimen type, result type, result options, and work domains.
     * @param pageNumber The page number for paginated results. Defaults to 1.
     * @param pageSize The number of items per page for paginated results. Defaults to 10.
     * @param searchTerm The term to search for within the investigation types.
     * @param isActive Indicates whether to include only active investigation types in the results.
     * @param isRapidTest Only rapid tests usable for screening (true), only the others (false), or all (omitted).
     * @param ids A collection of investigation type IDs to filter by.
     * @param categoryIds A collection of category IDs to filter by.
     * @param medicalSpecialityIds A collection of unique identifiers representing specific medical specialties.
     * Used to filter investigation classifiers based on associated medical specialties.
     * @param deviceTypeIds A collection of device type IDs to filter by.
     * @param workMethodIds A collection of work method IDs to filter by.
     * @param workDomainIds A collection of work domain IDs to filter by.
     * @param specimenTypeIds A collection of specimen type IDs to filter by.
     * @param specimenStorageConditionIds A collection of specimen storage conditions IDs to filter by.
     * @param code A code string used to filter investigation classifiers based on
     * specific identifier or unique value associated with them.
     * @returns SearchInvestigationTypeQueryResponse The list of Investigation Type classifier elements.
     * @throws ApiError
     */
    public static getInvestigationClassifierListEndpoint(
        pageNumber: number,
        pageSize: number,
        searchTerm?: string | null,
        isActive?: boolean | null,
        isRapidTest?: boolean | null,
        ids?: Array<string> | null,
        categoryIds?: Array<string> | null,
        medicalSpecialityIds?: Array<string> | null,
        deviceTypeIds?: Array<string> | null,
        workMethodIds?: Array<string> | null,
        workDomainIds?: Array<string> | null,
        specimenTypeIds?: Array<string> | null,
        specimenStorageConditionIds?: Array<string> | null,
        code?: string | null,
    ): CancelablePromise<SearchInvestigationTypeQueryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/investigations/types',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'isActive': isActive,
                'isRapidTest': isRapidTest,
                'ids': ids,
                'categoryIds': categoryIds,
                'medicalSpecialityIds': medicalSpecialityIds,
                'deviceTypeIds': deviceTypeIds,
                'workMethodIds': workMethodIds,
                'workDomainIds': workDomainIds,
                'specimenTypeIds': specimenTypeIds,
                'specimenStorageConditionIds': specimenStorageConditionIds,
                'code': code,
            },
            errors: {
                400: `One or more request parameters are invalid.`,
                401: `The user is not authorized to access this resource.`,
            },
        });
    }
    /**
     * Creates an Investigation Type element.
     * Creates an Investigation Type classifier element with detailed metadata such as category, method, specimen, and result options.
     * @param requestBody
     * @returns CreateInvestigationClassifierResponse The investigation classifier element has been created successfully.
     * @throws ApiError
     */
    public static createInvestigationClassifierEndpoint(
        requestBody: CreateInvestigationClassifierRequest,
    ): CancelablePromise<CreateInvestigationClassifierResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/classifiers/investigations/types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided or invalid.`,
                401: `User is not authorized to perform this operation.`,
                404: `Classifier not found.`,
            },
        });
    }
    /**
     * Obtain a filtered list of Investigation test types.
     * Obtain a filtered list of Investigation test types.
     * @param pageNumber The page number for paginated results. Defaults to 1.
     * @param pageSize The number of items per page for paginated results. Defaults to 10.
     * @param searchTerm The term to search for within the investigation types.
     * @param ids A collection of investigation type IDs to filter by.
     * @param categoryIds A collection of category IDs to filter by.
     * @param infectionIds A collection of infection IDs to filter by.
     * @param deviceTypeIds A collection of device type IDs to filter by.
     * @param workMethodIds A collection of work method IDs to filter by.
     * @param workDomainIds A collection of work domain IDs to filter by.
     * @param specimenTypeIds A collection of specimen type IDs to filter by.
     * @param investigationTypeIds
     * @param specimenStorageConditionIds A collection of specimen storage conditions IDs to filter by.
     * @param resultTypeIds A collection of result type IDs to filter by.
     * @param resultOptionIds A collection of result option IDs to filter by.
     * @param resultUnitMeasureIds A collection of result unit measure IDs to filter by.
     * @param resultReferenceIntervalIds A collection of result reference interval IDs to filter by.
     * @param resultValueOptionIds A collection of result value option IDs to filter by.
     * @param isActive Indicates whether to include only active investigation test types in the results.
     * @param types A collection of investigation test type categories to filter by (A1, A2, A3, Other).
     * @returns SearchInvestigationTestTypesQueryResponse The list of Investigation test types.
     * @throws ApiError
     */
    public static getListInvestigationTestTypeEndpoint(
        pageNumber: number,
        pageSize: number,
        searchTerm?: string | null,
        ids?: Array<string> | null,
        categoryIds?: Array<string> | null,
        infectionIds?: Array<string> | null,
        deviceTypeIds?: Array<string> | null,
        workMethodIds?: Array<string> | null,
        workDomainIds?: Array<string> | null,
        specimenTypeIds?: Array<string> | null,
        investigationTypeIds?: Array<string> | null,
        specimenStorageConditionIds?: Array<string> | null,
        resultTypeIds?: Array<string> | null,
        resultOptionIds?: Array<string> | null,
        resultUnitMeasureIds?: Array<string> | null,
        resultReferenceIntervalIds?: Array<string> | null,
        resultValueOptionIds?: Array<string> | null,
        isActive?: boolean | null,
        types?: Array<InvestigationTestTypeCategory> | null,
    ): CancelablePromise<SearchInvestigationTestTypesQueryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/investigations/tests/types',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'ids': ids,
                'categoryIds': categoryIds,
                'infectionIds': infectionIds,
                'deviceTypeIds': deviceTypeIds,
                'workMethodIds': workMethodIds,
                'workDomainIds': workDomainIds,
                'specimenTypeIds': specimenTypeIds,
                'investigationTypeIds': investigationTypeIds,
                'specimenStorageConditionIds': specimenStorageConditionIds,
                'resultTypeIds': resultTypeIds,
                'resultOptionIds': resultOptionIds,
                'resultUnitMeasureIds': resultUnitMeasureIds,
                'resultReferenceIntervalIds': resultReferenceIntervalIds,
                'resultValueOptionIds': resultValueOptionIds,
                'isActive': isActive,
                'types': types,
            },
            errors: {
                400: `One or more request parameters are invalid.`,
                401: `The user is not authorized to access this resource.`,
            },
        });
    }
    /**
     * Obtain an Investigation test type.
     * Obtain an Investigation test type.
     * @param id Gets the identifier of the investigation test type classifier.
     * @returns InvestigationTestTypeDto2 Success
     * @throws ApiError
     */
    public static getInvestigationTestTypeEndpoint(
        id: string,
    ): CancelablePromise<InvestigationTestTypeDto2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/investigations/tests/types/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The provided identifier is invalid or missing.`,
                401: `The user is not authorized to perform this operation.`,
                404: `No Investigation Type classifier element was found for the given identifier.`,
            },
        });
    }
    /**
     * Deletes an Investigation test type.
     * Deletes an Investigation test type.
     * @param id Gets or sets the unique identifier of the element.
     * @returns any The Investigation test type was successfully deleted.
     * @throws ApiError
     */
    public static deleteInvestigationTestTypeEndpoint(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/classifiers/investigations/tests/types/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The provided identifier is invalid or missing.`,
                401: `The user is not authorized to perform this operation.`,
                404: `No Investigation Type classifier element was found for the given identifier.`,
            },
        });
    }
    /**
     * Updates an existing result value option classifier element.
     * This endpoint updates the details of an existing result value option classifier element, including its translation, order, and comments, based on the provided classifier ID and element ID.
     * @param id Gets or sets the unique identifier of the result value option.
     * @param requestBody
     * @returns UpdateResultValueOptionResponse The result value option classifier element was successfully updated.
     * @throws ApiError
     */
    public static updateResultValueOptionEndpoint(
        id: string,
        requestBody: UpdateResultValueOptionRequest,
    ): CancelablePromise<UpdateResultValueOptionResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/classifiers/investigations/results/value-options/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request was invalid or contained incorrect parameters.`,
                401: `The user is not authorized to update this resource.`,
                404: `The specified classifier or element was not found.`,
                500: `An internal error occurred while processing the request.`,
            },
        });
    }
    /**
     * Deletes a result value option classifier element.
     * Removes a result value option classifier element from the specified classifier, based on the provided element ID.
     * @param id Gets or initializes the ID of the result value option element to delete.
     * @returns void
     * @throws ApiError
     */
    public static deleteResultValueOptionEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/classifiers/investigations/results/value-options/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The request was invalid or missing required fields.`,
                401: `The user is not authorized to perform this action.`,
                404: `The specified classifier or classifier element was not found.`,
            },
        });
    }
    /**
     * Retrieves a paginated list of Quantitative Result Type classifier elements.
     * Fetches a paginated list of Quantitative Result Type classifier elements associated with a specific classifier. The list can be paged by specifying the page number and page size.
     * @param pageNumber
     * @param pageSize
     * @returns GetListResultValueOptionsResponse The list of Quantitative Result Type classifier elements was successfully retrieved.
     * @throws ApiError
     */
    public static getListResultValueOptionsEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<GetListResultValueOptionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/investigations/results/value-options',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `The request was invalid, or the provided parameters are incorrect.`,
                401: `The user is not authorized to access this resource.`,
                404: `The specified classifier was not found.`,
            },
        });
    }
    /**
     * Creates a new result value option classifier element.
     * Registers a new result value option classifier element under the specified classifier, with translation support and optional comments.
     * @param requestBody
     * @returns CreateResultValueOptionResponse The result value option classifier element was successfully created.
     * @throws ApiError
     */
    public static createResultValueOptionEndpoint(
        requestBody: CreateResultValueOptionRequest,
    ): CancelablePromise<CreateResultValueOptionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/classifiers/investigations/results/value-options',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The request was invalid or missing required fields.`,
                401: `The user is not authorized to perform this action.`,
                404: `The specified classifier was not found.`,
            },
        });
    }
    /**
     * Retrieves a specific result value option classifier element.
     * Fetches a result value option classifier element from a classifier, identified by both the classifier ID and the element ID.
     * @param elementId
     * @returns GetResultValueOptionResponse Success
     * @throws ApiError
     */
    public static getResultValueOptionEndpoint(
        elementId: string,
    ): CancelablePromise<GetResultValueOptionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/investigations/results/value-options/{elementId}',
            path: {
                'elementId': elementId,
            },
            errors: {
                400: `The request was invalid or missing required fields.`,
                401: `The user is not authorized to access this resource.`,
                404: `The specified classifier or classifier element was not found.`,
            },
        });
    }
    /**
     * Updates a reference interval classifier element.
     * Updates the data for a specific reference interval classifier element used in investigations.
     * @param id
     * @param requestBody
     * @returns UpdateReferenceIntervalClassifierElementResponse Updated successfully.
     * @throws ApiError
     */
    public static updateReferenceIntervalClassifierElementEndpoint(
        id: string,
        requestBody: UpdateReferenceIntervalClassifierElementRequest,
    ): CancelablePromise<UpdateReferenceIntervalClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/classifiers/investigations/reference-intervals/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request data was provided.`,
                401: `The user is not authorized.`,
                404: `The classifier element with the given ID was not found.`,
            },
        });
    }
    /**
     * Retrieves a reference interval classifier element by ID.
     * Fetches a reference interval classifier element from the database using the provided unique identifier.
     * @param id Gets or sets the unique identifier of the classifier element.
     * @returns GetReferenceIntervalClassifierElementResponse Successfully retrieved the classifier element.
     * @throws ApiError
     */
    public static getReferenceIntervalClassifierElementEndpoint(
        id: string,
    ): CancelablePromise<GetReferenceIntervalClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/investigations/reference-intervals/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `The user is not authorized.`,
                404: `No classifier element found with the given ID.`,
            },
        });
    }
    /**
     * Deletes a reference interval classifier element.
     * Deletes a reference interval classifier element identified by its unique ID.
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteReferenceIntervalClassifierElementEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/classifiers/investigations/reference-intervals/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID or deletion failed due to validation errors.`,
                401: `The user is not authorized.`,
            },
        });
    }
    /**
     * Retrieves a paginated list of reference interval classifier elements.
     * Fetches a paginated list of reference interval classifier elements used in investigations, ordered by `Order` and `Created` date.
     * @param pageNumber
     * @param pageSize
     * @returns GetReferenceIntervalClassifierElementListResponse List retrieved successfully.
     * @throws ApiError
     */
    public static getReferenceIntervalClassifierElementListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<GetReferenceIntervalClassifierElementListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/investigations/reference-intervals',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                401: `The user is not authorized.`,
            },
        });
    }
    /**
     * Creates a reference interval classifier element.
     * Creates a reference interval classifier element.
     * @param requestBody
     * @returns CreateReferenceIntervalClassifierElementResponse Created successfully
     * @throws ApiError
     */
    public static createReferenceIntervalClassifierElementEndpoint(
        requestBody: CreateReferenceIntervalClassifierElementRequest,
    ): CancelablePromise<CreateReferenceIntervalClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/classifiers/investigations/reference-intervals',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request data was provided.`,
                401: `The user is not authorized.`,
            },
        });
    }
    /**
     * Updates a device type classifier element.
     * Updates an existing device type classifier element with new information, including translation, inspection period, order, and comments.
     * @param elementId
     * @param requestBody
     * @returns UpdateDeviceTypeClassifierElementResponse The device type classifier element was updated successfully.
     * @throws ApiError
     */
    public static updateDeviceTypeClassifierElementEndpoint(
        elementId: string,
        requestBody: UpdateDeviceTypeClassifierElementRequest,
    ): CancelablePromise<UpdateDeviceTypeClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/classifiers/institutions/device-types/{elementId}',
            path: {
                'elementId': elementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `The user is not authorized to update the element.`,
                404: `The specified device type classifier element was not found.`,
            },
        });
    }
    /**
     * Retrieves a device type classifier element.
     * Fetches the details of a specific device type classifier element, identified by its unique ID.
     * @param elementId
     * @returns InstitutionDeviceTypeDto The device type classifier element was retrieved successfully.
     * @throws ApiError
     */
    public static getDeviceTypeClassifierElementEndpoint(
        elementId: string,
    ): CancelablePromise<InstitutionDeviceTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/institutions/device-types/{elementId}',
            path: {
                'elementId': elementId,
            },
            errors: {
                401: `The user is not authorized.`,
                404: `The specified device type classifier element could not be found.`,
            },
        });
    }
    /**
     * Deletes a device type classifier element.
     * Removes a specific classifier element used for device types, identified by its unique ID.
     * @param elementId
     * @returns void
     * @throws ApiError
     */
    public static deleteDeviceTypeClassifierElementEndpoint(
        elementId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/classifiers/institutions/device-types/{elementId}',
            path: {
                'elementId': elementId,
            },
            errors: {
                400: `Invalid request or element could not be deleted.`,
                401: `The user is not authorized.`,
            },
        });
    }
    /**
     * Retrieves a list of device type classifier elements.
     * Fetches a paginated list of device type classifier elements associated with a specific classifier ID.
     * @param classifierId
     * @param pageNumber
     * @param pageSize
     * @returns SearchInstitutionDeviceTypeQueryResponse The list of device type classifier elements was retrieved successfully.
     * @throws ApiError
     */
    public static getDeviceTypeClassifierElementListEndpoint(
        classifierId: string,
        pageNumber: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<SearchInstitutionDeviceTypeQueryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/{classifierId}/institutions/device-types',
            path: {
                'classifierId': classifierId,
            },
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                401: `The user is not authorized.`,
                404: `The specified classifier was not found.`,
            },
        });
    }
    /**
     * Creates a new device type classifier element.
     * Adds a new classifier element for device types, associated with a specific classifier ID.
     * @param classifierId
     * @param requestBody
     * @returns CreateDeviceTypeClassifierElementResponse The device type classifier element has been created successfully.
     * @throws ApiError
     */
    public static createDeviceTypeClassifierElementEndpoint(
        classifierId: string,
        requestBody: CreateDeviceTypeClassifierElementRequest,
    ): CancelablePromise<CreateDeviceTypeClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/classifiers/{classifierId}/institutions/device-types',
            path: {
                'classifierId': classifierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request data was provided.`,
                401: `The user is not authorized.`,
            },
        });
    }
    /**
     * Updates an ICD-10-AM classifier element.
     * Updates an ICD-10-AM classifier element with provided details.
     * @param id Classifier identifier.
     * @param elementId Element identifier.
     * @param requestBody
     * @returns UpdateIcd10AmClassifierElementResponse The ICD-10-AM classifier element has been updated successfully.
     * @throws ApiError
     */
    public static updateIcd10AmClassifierElementEndpoint(
        id: string,
        elementId: string,
        requestBody: UpdateIcd10AmClassifierElementRequest,
    ): CancelablePromise<UpdateIcd10AmClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/classifiers/{id}/icd10am-elements/{elementId}',
            path: {
                'id': id,
                'elementId': elementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Classifier/ICD-10-AM classifier element not found.`,
            },
        });
    }
    /**
     * Gets an ICD-10-AM classifier element.
     * Gets an ICD-10-AM classifier element with details.
     * @param id Classifier identifier.
     * @param elementId Element identifier.
     * @returns GetIcd10AmClassifierElementResponse The ICD-10-AM classifier element has been retrieved successfully.
     * @throws ApiError
     */
    public static getIcd10AmClassifierElementEndpoint(
        id: string,
        elementId: string,
    ): CancelablePromise<GetIcd10AmClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/{id}/icd10am-elements/{elementId}',
            path: {
                'id': id,
                'elementId': elementId,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Classifier/ICD-10-AM classifier element not found.`,
            },
        });
    }
    /**
     * Marks an ICD-10-AM element as belonging to a special list (e.g. Form 058-1/e opportunistic diseases)
     * Sets or clears (null type) the special list of an ICD-10-AM classifier element. Elements of type opportunisticDisease are the diseases listed in field 56 of Form 058-1/e; a listed code also covers its sub-codes, and a range (A15-A16) every code in it.
     * @param id Classifier identifier.
     * @param elementId Element identifier.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static setIcd10AmTypeEndpoint(
        id: string,
        elementId: string,
        requestBody: SetIcd10AmTypeRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/classifiers/{id}/icd10am-elements/{elementId}/type',
            path: {
                'id': id,
                'elementId': elementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The type is not valid.`,
                401: `User is not authorized.`,
                404: `Classifier/ICD-10-AM classifier element not found.`,
            },
        });
    }
    /**
     * Gets a list of ICD-10-AM classifier elements.
     * Gets a list of ICD-10-AM classifier elements.
     * @param id Classifier identifier.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param ids Seatch by an array of ICD-10-AM classifier elements ids
     * @param searchTerm Search by disease code, name in Romanian/Russian and parent code. Partial search supported.
     * @param type Only elements of this special list, e.g. the opportunistic diseases of Form 058-1/e.
     * @returns GetIcd10AmClassifierElementListResponse List of ICD-10-AM classifier elements has been retrieved successfully.
     * @throws ApiError
     */
    public static getIcd10AmClassifierElementListEndpoint(
        id: string,
        pageNumber: number = 1,
        pageSize: number = 10,
        ids?: Array<string> | null,
        searchTerm?: string | null,
        type?: Icd10AmElementType | null,
    ): CancelablePromise<GetIcd10AmClassifierElementListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/{id}/icd10am-elements',
            path: {
                'id': id,
            },
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'ids': ids,
                'searchTerm': searchTerm,
                'type': type,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a list of classifiers.
     * Gets a list of classifiers.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by the classifier name.
     * @param category Filter by the classifier category.
     * @returns GetClassifierListResponse List of classifiers has been retrieved successfully.
     * @throws ApiError
     */
    public static getClassifierListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        category?: ClassifierCategory | null,
    ): CancelablePromise<GetClassifierListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'category': category,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Updates a CUATM classifier element.
     * Updates a CUATM classifier element with provided details.
     * @param elementId Element identifier.
     * @param requestBody
     * @returns UpdateCuatmClassifierElementResponse The CUATM classifier element has been updated successfully.
     * @throws ApiError
     */
    public static updateCuatmClassifierElementEndpoint(
        elementId: string,
        requestBody: UpdateCuatmClassifierElementRequest,
    ): CancelablePromise<UpdateCuatmClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/classifiers/cuatm-elements/{elementId}',
            path: {
                'elementId': elementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Classifier/CUATM classifier element not found.`,
            },
        });
    }
    /**
     * Gets a CUATM classifier element.
     * Gets a CUATM classifier element with details.
     * @param elementId Element identifier.
     * @returns GetCuatmClassifierElementResponse The CUATM classifier element has been retrieved successfully.
     * @throws ApiError
     */
    public static getCuatmClassifierElementEndpoint(
        elementId: string,
    ): CancelablePromise<GetCuatmClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/cuatm-elements/{elementId}',
            path: {
                'elementId': elementId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Classifier/CUATM classifier element not found.`,
            },
        });
    }
    /**
     * Delete a CUATM classifier element.
     * Delete a CUATM classifier element with provided details.
     * @param elementId Element identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteCuatmClassifierElementEndpoint(
        elementId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/classifiers/cuatm-elements/{elementId}',
            path: {
                'elementId': elementId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Classifier/CUATM classifier element not found.`,
            },
        });
    }
    /**
     * Gets a list of CUATM classifier elements.
     * Gets a list of CUATM classifier elements.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param code Code. Partial search supported.
     * @param nameRo Name in Romanian. Partial search supported.
     * @param nameRu Name in Russian. Partial search supported.
     * @param parentCode Parent code.
     * @param parentClassifierElementId Parent classifier Id.
     * @param hasParent Check is element has parent or not.
     * @returns GetCuatmClassifierElementListResponse List of CUATM classifier elements has been retrieved successfully.
     * @throws ApiError
     */
    public static getCuatmClassifierElementListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        code?: string | null,
        nameRo?: string | null,
        nameRu?: string | null,
        parentCode?: string | null,
        parentClassifierElementId?: string | null,
        hasParent?: boolean | null,
    ): CancelablePromise<GetCuatmClassifierElementListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/cuatm-elements',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'code': code,
                'nameRO': nameRo,
                'nameRU': nameRu,
                'parentCode': parentCode,
                'parentClassifierElementId': parentClassifierElementId,
                'hasParent': hasParent,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Create a CUATM classifier element.
     * Create a CUATM classifier element with provided details.
     * @param requestBody
     * @returns CreateCUATMClassifierElementResponse The CUATM classifier element has been created successfully.
     * @throws ApiError
     */
    public static createCuatmClassifierElementEndpoint(
        requestBody: CreateCUATMClassifierElementRequest,
    ): CancelablePromise<CreateCUATMClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/classifiers/cuatm-elements',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Classifier/CUATM classifier element not found.`,
            },
        });
    }
    /**
     * Gets a list of countries.
     * Gets a list of countries.
     * @returns GetCountryClassifierElementListResponse List of classifiers has been retrieved successfully.
     * @throws ApiError
     */
    public static getCountryClassifierElementListEndpoint(): CancelablePromise<GetCountryClassifierElementListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/countries',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The required parameters were not provided.`,
            },
        });
    }
    /**
     * Updates a common classifier element.
     * Updates a common classifier element with provided details.
     * @param id Classifier identifier.
     * @param elementId Element identifier.
     * @param requestBody
     * @returns UpdateCommonClassifierElementResponse The common classifier element has been updated successfully.
     * @throws ApiError
     */
    public static updateCommonClassifierElementEndpoint(
        id: string,
        elementId: string,
        requestBody: UpdateCommonClassifierElementRequest,
    ): CancelablePromise<UpdateCommonClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/classifiers/{id}/common-elements/{elementId}',
            path: {
                'id': id,
                'elementId': elementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Classifier/common classifier element not found.`,
            },
        });
    }
    /**
     * Gets a common classifier element.
     * Gets a common classifier element with details.
     * @param id Classifier identifier.
     * @param elementId Element identifier.
     * @returns GetCommonClassifierElementResponse The common classifier element has been retrieved successfully.
     * @throws ApiError
     */
    public static getCommonClassifierElementEndpoint(
        id: string,
        elementId: string,
    ): CancelablePromise<GetCommonClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/{id}/common-elements/{elementId}',
            path: {
                'id': id,
                'elementId': elementId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `Classifier/common classifier element not found.`,
            },
        });
    }
    /**
     * Deletes a common classifier element.
     * Deletes a common classifier element from the classifier.
     * @param id Classifier identifier.
     * @param elementId Element identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteCommonClassifierElementEndpoint(
        id: string,
        elementId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/classifiers/{id}/common-elements/{elementId}',
            path: {
                'id': id,
                'elementId': elementId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The classifier / common classifier element has not been found.`,
                409: `The common classifier element is in use and cannot be deleted.`,
            },
        });
    }
    /**
     * Maps a system key (used by Form 058-1/e) to a classifier element
     * Sets or clears (null key) the system key of a common classifier element. Unique keys can be held by a single element of the classifier.
     * @param id Classifier identifier.
     * @param elementId Element identifier.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static setSystemKeyEndpoint(
        id: string,
        elementId: string,
        requestBody: SetSystemKeyRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/classifiers/{id}/common-elements/{elementId}/system-key',
            path: {
                'id': id,
                'elementId': elementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The key is not allowed for the classifier type.`,
                401: `Unauthorized`,
                404: `Classifier/common classifier element not found.`,
                409: `The unique key is held by another element.`,
            },
        });
    }
    /**
     * Gets a list of common classifier elements.
     * Gets a list of common classifier elements.
     * @param id Classifier identifier.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @returns GetCommonClassifierElementListResponse List of common classifier elements has been retrieved successfully.
     * @throws ApiError
     */
    public static getCommonClassifierElementListEndpoint(
        id: string,
        pageNumber: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<GetCommonClassifierElementListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/{id}/common-elements',
            path: {
                'id': id,
            },
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a common classifier element.
     * Creates a common classifier element within the classifier.
     * @param id Classifier identifier.
     * @param requestBody
     * @returns CreateCommonClassifierElementResponse The classifier element has been created successfully.
     * @throws ApiError
     */
    public static createCommonClassifierElementEndpoint(
        id: string,
        requestBody: CreateCommonClassifierElementRequest,
    ): CancelablePromise<CreateCommonClassifierElementResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/classifiers/{id}/common-elements',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The classifier has not been found.`,
            },
        });
    }
    /**
     * Gets a list of classifier categories.
     * Gets a list of classifier categories.
     * @returns GetCategoryListResponse List of classifier categories has been retrieved successfully
     * @throws ApiError
     */
    public static getCategoryListEndpoint(): CancelablePromise<GetCategoryListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/classifiers/categories',
            errors: {
                401: `User is not authorized.`,
            },
        });
    }
}
